module.exports = __webpack_public_path__ + "static/media/atlas.fc2e4043.png";


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/atlas.png
// module id = 180
// module chunks = 0